import { render, staticRenderFns } from "./completed-page.vue?vue&type=template&id=1938096c&scoped=true&"
import script from "./completed-page.vue?vue&type=script&lang=js&"
export * from "./completed-page.vue?vue&type=script&lang=js&"
import style0 from "./completed-page.vue?vue&type=style&index=0&id=1938096c&prod&scoped=true&lang=less&"
import style1 from "./completed-page.vue?vue&type=style&index=1&id=1938096c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1938096c",
  null
  
)

export default component.exports